import { useState } from 'react'
import PropTypes from 'prop-types'
import { Select, message } from 'antd'
import api from '../../api'
import { teamShape, practiceShape } from '../prop-types'

// Team picker for a practice row. Extracted from Practices so both the desktop
// column and the mobile card can render it without importing each other.
export default function SelectTeam({ practice, teams, width = '90%' }) {
  const [teamIds, setTeamIds] = useState(practice.teamIds)

  return (
    <Select
      mode="multiple"
      optionFilterProp="children"
      placeholder="Select teams"
      value={teamIds}
      onChange={async newTeamIds => {
        try {
          const result = await api.teams.updatePracticeTeams(
            practice.id,
            newTeamIds,
          )
          setTeamIds(result)
        } catch (error) {
          message.error(
            `There was an error updating the teams: ${error.message}`,
          )
        }
      }}
      style={{ width }}
    >
      {teams.map(team => (
        <Select.Option key={team.id} value={team.id}>
          {team.name}
        </Select.Option>
      ))}
    </Select>
  )
}

SelectTeam.propTypes = {
  teams: PropTypes.arrayOf(teamShape).isRequired,
  practice: practiceShape.isRequired,
  // Mobile renders the picker full width; the desktop column keeps 90%.
  width: PropTypes.string,
}
